import React from "react";
import classnames from "classnames";
import "./HorizontalRule.less";

type Props = React.ComponentPropsWithoutRef<"hr"> & {
    left?: boolean;
    short?: boolean;
};

const HorizontalRule: React.FC<Props> = ({ className, short, left, ...rest }) => (
    <hr
        className={classnames("horizontal-rule", className, {
            "horizontal-rule--short": short,
            "horizontal-rule--left": left,
        })}
        {...rest}
    />
);

export default HorizontalRule;
